import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import React, { useEffect, useState } from "react";
import "./information.css";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../firebaseConfig";
import conradLogo from "./booking/images/conrad-logo.png";
import addressLogo from "./booking/images/address-logo.jpg";

const Information = () => {
  const [hotels, setHotels] = useState<any[]>([]);
  const [isPublished, setIsPublished] = useState<boolean>(false);

  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [closeHotelRegistration, setCloseHotelRegistration] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 800) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
      }
    };

    // Check screen size on initial load
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchPublishSetting = async () => {
      try {
        const settingsSnapshot = await getDocs(collection(db, "settings"));
        settingsSnapshot.docs.forEach((doc) => {
          const data = doc.data();
          // setIsPublished(data.publishInformation || false);
          setIsPublished(true);
          setCloseHotelRegistration(data.closeHotelRegistration || false);
        });
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
    fetchPublishSetting();
  }, []);

  useEffect(() => {
    if (isPublished) {
      const fetchAccommodation = async () => {
        try {
          const snapshot = await getDocs(
            collection(db, "accommodation_and_travel")
          );
          const data = snapshot.docs
            .map((doc) => doc.data())
            .filter((item) => item.published);
          setHotels(data.filter((item) => item.type === "hotel"));
        } catch (err) {
          console.error("Error fetching hotels:", err);
        }
      };
      fetchAccommodation();
    }
  }, [isPublished]);

  if (!isPublished) return null;

  const conradHotel = hotels[0];
  const sliderImages = [
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604770/1_2x_iujifs.png", // modern hotel exterior
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604769/2_2x_qllc8p.png", // luxury lobby
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604770/3_2x_kqgwsg.png", // interior view
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604769/4_2x_vjhnm5.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604769/5_2x_v3u9v8.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604769/6_2x_mc6cuk.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604769/7_2x_ylicpz.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604768/8_2x_fah2tg.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1752604767/9_2x_njq70x.png", // bedroom / suite
  ];

  const theAddress = hotels[1];
  const sliderImagesAddress = [
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963591/5_jdvlp9.png", // bedroom / suite
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963580/8_a62lo5.png", // modern hotel exterior
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963580/1_bwihof.png", // luxury lobby
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963581/7_lwkwja.png", // interior view
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963584/6_etswpw.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963586/3_miuzca.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963589/2_bbegqo.png", // elegant hotel lounge
    "https://res.cloudinary.com/astcdubai/image/upload/v1760963590/4_a9bcur.png", // elegant hotel lounge
  ];

  return (
    <div
      id="information"
      className="information"
      style={{ borderBottom: "1px solid rgba(230, 167, 59, 0.6)" }}
    >
      {/* ========== Travel Section ========== */}
      {/* ========== Travel Section (Promo layout) ========== */}
      <div className="container">
        <div className="row">
          <div
            className={`col-sm-8 col-sm-offset-2 text-center ${
              isSmallScreen ? "mb-30" : "mb-10"
            }`}
          >
            <h1 className="title mt-40">Travel Information</h1>
          </div>
        </div>
        <div className="promo-box travel-box">
          {/* LEFT: Image slider like the Conrad box */}
          <div className="promo-image-slider">
            <img
              src="https://res.cloudinary.com/astcdubai/image/upload/v1735883694/emirates_white_kyy4oo.png"
              alt="Emirates Logo"
              className="travel-emirates-logo"
            />
          </div>

          {/* RIGHT: Title, text, button */}
          <div className="promo-content">
            {/* optional small logo tag above the title */}
            <h3 className="promo-title">
              TRAVEL WITH EMIRATES — STEP-BY-STEP GUIDE
            </h3>

            <p className="promo-text" style={{ color: "#fff" }}>
              <b>Emirates</b> is proud to be the official airline partner of the
              48th ICA Conference & Exhibition, extending an exclusive offer for
              registered delegates traveling to Dubai (DXB). Enjoy special
              fares, exceptional comfort, and award-winning service as you fly
              with Emirates to join us for this year’s conference.
            </p>

            <a
              href="https://mcusercontent.com/2217302eea64a52fe6bae760d/files/f99d9b37-1e9b-45c2-688d-ed05b09d3e50/ICA_Conference_and_Exhibition_Communication_flyer.pdf"
              className="booking-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Emirates Step-by-Step Travel Guide
            </a>
          </div>
        </div>
      </div>

      {/* Container */}
      <div className="container">
        {/* Row */}
        <div className="row">
          <div
            className={`col-sm-8 col-sm-offset-2 text-center ${
              isSmallScreen ? "mb-30" : "mb-10"
            }`}
          >
            <h1 className="title mt-40">Accommodation & Venue Information</h1>
            <p className="sub-title-3 mt-40 mb-20" style={{ color: "#fff" }}>
              The 48th ICA Conference & Exhibition will take place at Conrad
              Dubai, a 5-star property located in the city's central business
              district. The venue offers a practical and well-equipped setting
              for hosting international delegates, featuring top-tier amenities
              and easy access to transport, accommodation, and key areas across
              Dubai.
            </p>
          </div>
        </div>
        {/* End Row */}
      </div>
      {/* End Container */}

      {conradHotel && (
        <div className="conrad-section">
          <div className="conrad-image-map-wrapper">
            <div className="conrad-image-map">
              <div className="image-half">
                <img
                  src={conradHotel.imageUrl}
                  alt="Conrad Dubai"
                  className="conrad-image"
                />
              </div>
              <div className="map-half">
                <iframe
                  title="Conrad Dubai Location"
                  src="https://www.google.com/maps?q=Conrad+Dubai,+Sheikh+Zayed+Rd+-+Trade+Centre+1+-+Dubai,+UAE&output=embed"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="conrad-map"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Hotel Name + Address */}
          <div className="row">
            <div
              className={`col-sm-8 col-sm-offset-2 text-center ${
                isSmallScreen ? "mb-30" : "mb-10"
              }`}
            >
              <h1 className="subtitle" style={{ fontSize: 24 }}>
                Conrad Dubai
              </h1>
              <p className="sub-title-3 mt-10" style={{ color: "#fff" }}>
                Sheikh Zayed Road, Trade Centre, Dubai, UAE
              </p>
            </div>
          </div>

          <div className="row">
            <div
              className={`col-sm-8 col-sm-offset-2 text-center mt-80
              }`}
            >
              {/* Centered Logo */}
              <img
                src={conradLogo}
                alt="Conrad Logo"
                className="conrad-logo"
                width={"40%"}
              />
            </div>
          </div>
          <div className="promo-box">
            {/* LEFT: Swiper Slider */}
            <div className="promo-image-slider">
              <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={30}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={true}
                className="promo-slider"
              >
                {sliderImages.map((img: string, i: number) => (
                  <SwiperSlide key={i}>
                    <img src={img} alt={`Slide ${i}`} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* RIGHT: Static Text Content */}
            <div className="promo-content">
              <h3 className="promo-title">
                Stay Where It Happens – at Discount
              </h3>
              <p className="promo-text" style={{ color: "#fff" }}>
                Reserve your room at Conrad Dubai through our official booking
                link and enjoy exclusive discounted rates available only for ICA
                Conference delegates. Stay in five-star comfort at the
                conference venue itself, with a selection of elegant rooms and
                suites to match your needs. Conrad Dubai features world-class
                dining, a beautiful pool deck, and premium wellness facilities—
                offering both convenience and luxury.
                <br />
                <br />
                {!closeHotelRegistration && (
                  <>
                    Book early to secure your preferred room and enjoy a
                    seamless stay in Dubai.
                  </>
                )}
              </p>
              {!closeHotelRegistration && (
                <a
                  href={"https://icaconferencedubai.com/hotel"}
                  className="booking-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book Now at Discounted Rate
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Container */}
      <div className="container">
        {/* Row */}
        <div className="row">
          <div
            id="gala-dinner"
            className={`col-sm-8 col-sm-offset-2 text-center ${
              isSmallScreen ? "mb-30" : "mb-10"
            }`}
          >
            <h1 className="title mt-40">Gala Dinner</h1>
            <p className="sub-title-3 mt-40 mb-20" style={{ color: "#fff" }}>
              The Gala Dinner of the 48th ICA Conference will be held at Address
              Montgomerie, an exclusive 5-star venue set amidst the lush
              fairways of Emirates Hills. Offering a stunning blend of luxury
              and tranquility, the venue provides an unforgettable setting for
              an evening of celebration. Guests will enjoy gourmet dining,
              refined ambiance, and warm hospitality, all within a serene resort
              atmosphere just minutes from the heart of Dubai.
            </p>
          </div>
        </div>
        {/* End Row */}
      </div>
      {/* End Container */}

      {theAddress && (
        <div className="conrad-section">
          <div className="conrad-image-map-wrapper">
            <div className="conrad-image-map">
              <div className="image-half">
                <Swiper
                  modules={[Pagination, Autoplay]}
                  spaceBetween={30}
                  pagination={{ clickable: true }}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  loop={true}
                  className="promo-slider"
                >
                  {sliderImagesAddress.map((img: string, i: number) => (
                    <SwiperSlide key={i}>
                      <img src={img} alt={`Gala Slide ${i + 1}`} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="map-half">
                <iframe
                  title="Address Montgomerie Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.0143653715472!2d55.16153657648967!3d25.06750223693952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6c9623107819%3A0xbb96b315d5811e41!2sAddress%20Montgomerie!5e0!3m2!1sen!2sae!4v1760962310367!5m2!1sen!2sae"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="conrad-map"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Hotel Name + Address */}
          <div className="row">
            <div
              className={`col-sm-8 col-sm-offset-2 text-center ${
                isSmallScreen ? "mb-30" : "mb-10"
              }`}
            >
              <h1 className="subtitle" style={{ fontSize: 24 }}>
                The Address Montgomerie
              </h1>
              <p className="sub-title-3 mt-10" style={{ color: "#fff" }}>
                Emirates Hills, Dubai, UAE
              </p>
            </div>
          </div>

          <div className="row">
            <div
              className={`col-sm-8 col-sm-offset-2 text-center mt-10
              }`}
            >
              {/* Centered Logo */}
              <img
                src={addressLogo}
                alt="The Address Montgomerie Logo"
                className="conrad-logo"
                width={"40%"}
              />
            </div>
          </div>
        </div>
      )}

      <br />
      <br />
    </div>
  );
};

export default Information;
